import { initializeMatomo } from '@ifg/libconsent';

// siteId is undefined if user is anonmous
const siteId: string = (window.drupalSettings as any).matomoSiteId;

initializeMatomo(siteId, false, {
  key: 'matomo',
  type: 'opt-in',
});
